// src/constants/planData.ts
export interface PlanFeature {
  feature: string;
  description?: string;
  included: boolean;
}

export interface PlanData {
  name: string;
  basePrice: number;
  whatsappIncluded: number;
  whatsappPrice: number;
  negotiationsIncluded: number;
  extraNegotiationsPrice: number;
  subscription: boolean;
  subscriptionCycle: 'WEEKLY' | 'MONTHLY' | 'YEARLY' | 'BIWEEKLY' | 'QUARTERLY' | 'SEMIANNUALLY';
  users: number;
  setupFee: number;
  features: PlanFeature[];
}

export const planData: Record<string, PlanData> = {
  /*
  Basic: {
    name: 'Basic',
    basePrice: 10,
    whatsappIncluded: 1,
    whatsappPrice: 0, // Não pode adicionar no plano Basic
    negotiationsIncluded: 2000,
    extraNegotiationsPrice: 499,
    subscription: true,
    subscriptionCycle: 'MONTHLY',
    users: 1,
    setupFee: 0,
    features: [
      { feature: "Especificação e Ajuste de Pedidos", included: true },
      { feature: "Busca e Expansão de Fornecedores", included: true },
      { feature: "Negociação Inteligente com Fornecedores", included: false },
      { feature: "Análise e Resumo das Negociações", description: "Tabela com resumo comparativo", included: false },
      { feature: "Suporte online", description: "via whatsapp no horário comercial", included: false }
    ]
  },
  */
  Advanced: {
    name: 'Advanced',
    basePrice: 4000,
    whatsappIncluded: 1,
    whatsappPrice: 247,
    negotiationsIncluded: 2000,
    extraNegotiationsPrice: 400,
    subscription: true,
    subscriptionCycle: 'MONTHLY',
    users: 5,
    setupFee: 10000,
    features: [
      { feature: "Especificação e Ajuste de Pedidos", included: true },
      { feature: "Busca e Expansão de Fornecedores", description: "Avançada, com adição de fornecedores após início", included: true },
      { feature: "Negociação Inteligente com Fornecedores", description: "Interação natural via WhatsApp", included: true },
      { feature: "Análise e Resumo das Negociações", description: "Versão Detalhada", included: true },
      { feature: "Suporte online", description: "via whatsapp no horário comercial", included: true }
    ]
  },
  Pro: {
    name: 'Pro',
    basePrice: 10000,
    whatsappIncluded: 1,
    whatsappPrice: 247,
    negotiationsIncluded: 10000,
    extraNegotiationsPrice: 400,
    subscription: true,
    subscriptionCycle: 'MONTHLY',
    users: 5,
    setupFee: 15000,
    features: [
      { feature: "Especificação e Ajuste de Pedidos", description: "Com apoio da IA para descrições de itens desconhecidos ou incompletos", included: true },
      { feature: "Busca e Expansão de Fornecedores", description: "Avançada, com adição de fornecedores após início", included: true },
      { feature: "Negociação Inteligente com Fornecedores", description: "Interação humana e persuasiva da IA via WhatsApp", included: true },
      { feature: "Análise e Resumo das Negociações", description: "Comparativo de preços automático", included: true },
      { feature: "Suporte online", description: "via whatsapp no horário comercial", included: true }
    ]
  },
  Premium: {
    name: 'Premium',
    basePrice: 15000,
    whatsappIncluded: 1,
    whatsappPrice: 200,
    negotiationsIncluded: 15000,
    extraNegotiationsPrice: 200,
    subscription: true,
    subscriptionCycle: 'MONTHLY',
    users: 20,
    setupFee: 25000,
    features: [
      { feature: "Especificação e Ajuste de Pedidos", description: "Com apoio da IA para descrições de itens desconhecidos ou incompletos", included: true },
      { feature: "Busca e Expansão de Fornecedores", description: "Mapeamento de fornecedores geo referenciado para seleção por proximidade", included: true },
      { feature: "Negociação Inteligente com Fornecedores", description: "Volume adicional para empresas com equipes distribuidas e demanda diária", included: true },
      { feature: "Análise e Resumo das Negociações", description: "Disputa em Tempo Real com Monitoramento Avançado", included: true },
      { feature: "Suporte Premium", description: "Time de Sucesso do cliente disponível com atendimento prioritário", included: true }
    ]
  },
};
